export const strings = {
  en: {
    cumulativeImpactTitle: () => `What we've funded`,
    cumulativeImpactDescription: () =>
      "Here's the impact that our community has made so far in partnership with Beam. Our impact is growing every day— scroll to check out the goals we're working toward together right now.",
  },
  fr: {
    cumulativeImpactTitle: () => `Ce que nous avons financé`,
    cumulativeImpactDescription: () =>
      "Voici l'impact que notre communauté a eu jusqu'à présent en partenariat avec Beam. Notre impact grandit chaque jour : faites défiler pour découvrir les objectifs vers lesquels nous travaillons ensemble en ce moment.",
  },
  de: {
    cumulativeImpactTitle: () => `Was wir finanziert haben`,
    cumulativeImpactDescription: () =>
      "Hier ist die Wirkung, die unsere Community bisher in Zusammenarbeit mit Beam erzielt hat. Unsere Wirkung wächst von Tag zu Tag - scrollen Sie, um einen Blick auf die Ziele zu werfen, auf die wir derzeit gemeinsam hinarbeiten.",
  },
  es: {
    cumulativeImpactTitle: () => `Lo que hemos financiado`,
    cumulativeImpactDescription: () =>
      "Este es el impacto que nuestra comunidad ha tenido hasta ahora en asociación con Beam. Nuestro impacto crece cada día; desplácese para ver los objetivos por los que estamos trabajando juntos en este momento.",
  },
  it: {
    cumulativeImpactTitle: () => `Cosa abbiamo finanziato`,
    cumulativeImpactDescription: () =>
      "Ecco l'impatto che la nostra comunità ha avuto finora in collaborazione con Beam. Il nostro impatto cresce ogni giorno: scorri per scoprire gli obiettivi a cui stiamo lavorando insieme in questo momento.",
  },
  pl: {
    cumulativeImpactTitle: () => `Co sfinansowaliśmy`,
    cumulativeImpactDescription: () =>
      "Oto wpływ, jaki nasza społeczność wywarła dotychczas we współpracy z Beam. Nasz wpływ rośnie z każdym dniem — przewiń, aby sprawdzić cele, nad którymi obecnie wspólnie pracujemy.",
  },
};
